import { createFileRoute } from '@tanstack/react-router';

import { JobForm } from '@/components/organisms/jobs/JobForm';

export const Route = createFileRoute('/_dashboard/dashboard/jobs/$id/edit')({
  component: EditJobPage,
});

function EditJobPage() {
  const { id } = Route.useParams();
  return <JobForm mode="edit" jobId={id} />;
}
